import React, { useState } from 'react';

const loadData = (itemName) => {
    try {
        const serializedState = localStorage.getItem(itemName)
        if (serializedState === null) {
            return undefined
        } else {
            return JSON.parse(serializedState)
        }
    } catch (error) {
        return undefined
    }
}

const saveData = (itemName, jsonData) => {
    try {
        const serializedState = JSON.stringify(jsonData)
        localStorage.setItem(itemName, serializedState)
        return true;
    } catch (error) {
        console.log(error.message)
        return false;
    }
}

export {
    loadData,
    saveData,
}


const UserContext = React.createContext()

export const UserProvider = UserContext.Provider;

export const UserConsumer = UserContext.Consumer;

export default UserContext